import { render } from "./TicketTab.vue?vue&type=template&id=7864d1f7&scoped=true"
import script from "./TicketTab.vue?vue&type=script&lang=js"
export * from "./TicketTab.vue?vue&type=script&lang=js"

import "./TicketTab.vue?vue&type=style&index=0&id=7864d1f7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7864d1f7"]])

export default __exports__